module.exports = __webpack_public_path__ + "static/img/coffee-logo.44eb4ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coffee-logo.png
// module id = sqLK
// module chunks = 16